import React from "react";
import { Button } from "@mui/material";

const DownloadBrandsButton = () => {
 const handleDownload = async () => {
  try {
   const response = await fetch(
    "https://app-api.carexpert.org.in/api/brands/download-brands",
   );

   if (!response.ok) throw new Error("Download failed");

   const blob = await response.blob();
   const url = window.URL.createObjectURL(blob);

   const link = document.createElement("a");
   link.href = url;
   link.download = "brands.xlsx";
   document.body.appendChild(link);
   link.click();
   link.remove();
   window.URL.revokeObjectURL(url);
  } catch (err) {
   console.error("Download error:", err);
   alert("Failed to download file");
  }
 };

 return (
  <Button variant="contained" color="secondary" onClick={handleDownload}>
   📥 Download Brand List Excel
  </Button>
 );
};

export default DownloadBrandsButton;
